var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 67,
    viewBox: "0 0 75 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 52.5625H56.705M51.3 41.125H60.5C64.0723 41.125 65.8582 41.125 67.2674 41.7053C69.1457 42.4792 70.6384 43.9638 71.4166 45.8319C72 47.2334 72 49.0096 72 52.5625C72 56.1154 72 57.8916 71.4166 59.2931C70.6384 61.1612 69.1457 62.6458 67.2674 63.4197C65.8582 64 64.0723 64 60.5 64H14.5C10.9278 64 9.14169 64 7.73275 63.4197C5.85422 62.6458 4.36172 61.1612 3.58359 59.2931C3 57.8916 3 56.1154 3 52.5625C3 49.0096 3 47.2334 3.58359 45.8319C4.36172 43.9638 5.85422 42.4792 7.73275 41.7053C9.14169 41.125 10.9278 41.125 14.5 41.125H23.7M37.5 44.9375V3M37.5 3L49 14.4375M37.5 3L26 14.4375",
    stroke: "black",
    strokeWidth: 4.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/Upload_Image_icon.28072026610e2b963ff493847a38ac1a.svg";
export { ForwardRef as ReactComponent };